import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {HTTP_STATUS} from '../../common/api-helpers';
import {AppConfigService} from '../config.service';

@Injectable()
export class GlobalSettingsApiService {

    protected readonly globalSettingsUrl = this.appConfigService.api['globalSettings'];

    constructor(
        protected appConfigService: AppConfigService,
        protected httpClient: HttpClient
    ) {}

    public store<T>(key: string, value: T): Observable<any> {
        const url: string = `${this.globalSettingsUrl}/${key}`;

        return this.httpClient.post(url, value);
    }

    public fetch<T>(key: string): Observable<T> {
        const url: string = `${this.globalSettingsUrl}/${key}`;

        return this.httpClient.get<T>(url, {
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<T>) => response.body),
            catchError((response: HttpResponse<T>) => response.status === HTTP_STATUS.NOT_FOUND
                ? of(null)
                : throwError(response)
            )
        );
    }

}
